"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var GameCollection = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var gameCardPlaceholder = _a.gameCardPlaceholder, category = _a.category, _h = _a.categoryTitle, categoryTitle = _h === void 0 ? '' : _h, _j = _a.provider, provider = _j === void 0 ? null : _j;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var categoryTitleText = translateLocale(categoryTitle) || category || t('all');
    var _k = (0, swr_hooks_1.useSearchGamesByFilters)({
        showCount: breakpoints.mobile ? 3 : 6,
        category: category,
        providerId: provider,
        withoutCache: true,
    }), data = _k.data, onLoadBtnClick = _k.onLoadBtnClick;
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var viewAllHandler = (0, react_1.useCallback)(function () {
        if (!category) {
            router.push(generateUrlWithLang("/games/all"));
        }
        else {
            router.push(generateUrlWithLang("/games/".concat(category)));
        }
    }, [router, category, generateUrlWithLang]);
    if (!data || ((_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c.length) === 0)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header, onClick: viewAllHandler },
                react_1.default.createElement("h3", null,
                    react_1.default.createElement("img", { src: "/img/game-filters/".concat(category === null ? 'all' : category, ".svg"), alt: category }),
                    categoryTitleText),
                react_1.default.createElement("button", null,
                    t('viewAll'),
                    ' ',
                    ((_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.totalCount) && react_1.default.createElement("span", null,
                        "(", (_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 :
                        _e.totalCount,
                        ")"),
                    react_1.default.createElement("img", { src: "/img/icons/arrow-right.svg", alt: "arrow-right" }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.games },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.gameItemWrapper }, (_g = (_f = data === null || data === void 0 ? void 0 : data.data) === null || _f === void 0 ? void 0 : _f.edges) === null || _g === void 0 ? void 0 : _g.map(function (game) {
                    var _a;
                    return (react_1.default.createElement("div", { key: game.id },
                        !breakpoints.tablet && !breakpoints.mobile && (react_1.default.createElement(ui_components_1.DesktopGameCard, { withDemo: (_a = game === null || game === void 0 ? void 0 : game.settings) === null || _a === void 0 ? void 0 : _a['demo'], key: "search_bar_dropdown_".concat(game.id, "}"), title: game.title, gameId: game.id, slug: game.slug, gameCardPlaceholder: gameCardPlaceholder, signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL })),
                        (breakpoints.tablet || breakpoints.mobile) && (react_1.default.createElement(ui_components_1.MobileGameCard, { key: "search_bar_dropdown_".concat(game.id, "}"), title: game.title, gameId: game.id, slug: game === null || game === void 0 ? void 0 : game.slug, gameCardPlaceholder: gameCardPlaceholder, gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL }))));
                }))))));
};
exports.default = GameCollection;
